import { Link } from "react-router-dom";

import "./BecomeFranchiseeButton.css";


export default function BecomeFranchiseeButton() {
    return (
        <Link 
            className="flash-btn-franchises"
            to="/franquias?shownav=true&sultsoriginid=26&utm_source=Botão%20Flutuante%20-%20Site"
            style={{ 
                textDecoration: 'none', 
                borderRadius: "15px", 
                minWidth: "150px", 
                height: "67px",
            }}
        >
            ╰•➤ Seja um Franqueado
        </Link>
    );
}